import { Component as BaseComponent, h } from 'preact';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {showDetails: false};
    }

    createMarkup(details) {
        return {__html: details};
    }

    render() {
        if (!this.props.details) {
            return (<product-details />);
        }

        return (
            <product-details onclick={() => this.handleToggleClick()}>
                <p>{ this.props.summary } <a>{ this.state.showDetails ? 'Show Less' : 'Learn More' }</a></p>
                { this.state.showDetails &&
                <p class='details' dangerouslySetInnerHTML={this.createMarkup(this.props.details)} />
                }
            </product-details>
        );
    }

    handleToggleClick() {
        this.setState({
            showDetails: !this.state.showDetails,
        });
    }
}

export default Component;



// WEBPACK FOOTER //
// ./app/components/product-details.js